import { render, staticRenderFns } from "./usaPayBreakdownSnapshot.vue?vue&type=template&id=071cda4b"
import script from "./usaPayBreakdownSnapshot.vue?vue&type=script&lang=js"
export * from "./usaPayBreakdownSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports